import { useLayoutEffect, useRef } from "react";

import { SingleProduct } from "../Product";
import { motion } from "framer-motion";
import { TProductDetail } from "../../types";
import { useFetchProducts } from "../../hooks/useFetchProducts";
import { SingleProductSekeleton } from "../Product/SingleProductSekeleton";

const Container = ({
  scrollOffset,
  col,
  products,
  className,
}: {
  scrollOffset: number;
  col?: boolean;
  products?: TProductDetail[];
  className?: string;
}) => {
  const { hasMore, loadMore, loading } = useFetchProducts();

  const containerRef = useRef<HTMLDivElement>(null);
  useLayoutEffect(() => {
    if (null !== containerRef.current) {
      containerRef.current.scrollLeft += scrollOffset;
    }
  }, [scrollOffset]);
  return (
    <>
      <motion.div
        ref={containerRef}
        initial={{ opacity: 0, x: 200 }}
        animate={{ opacity: 1, x: 0 }}
        exit={{ opacity: 0, x: 200 }}
        className={`${className} w-full mt-12 flex items-center ${
          (!products || col) && "justify-center"
        }   min-h-[200px] gap-4  px-2 ${
          !col
            ? "overflow-x-scroll scrollbar-hidden scroll-smooth"
            : "overflow-x-hidden flex-wrap"
        }`}
      >
        {products?.map((item: TProductDetail) => (
          <SingleProduct key={item.id} item={item} col={col} />
        ))}
        {products &&
          products.length <= 0 &&
          [...Array(10)].map((_, index) => {
            return <SingleProductSekeleton key={index + "product-skelecton"} />;
          })}
        {Boolean(products?.length && hasMore) && (
          <div className="flex justify-center w-full mb-10">
            <motion.button
              className={`w-full px-4 py-2 text-white transition-all duration-100 ease-in-out rounded-lg bg-gradient-to-br from-orange-400 to-orange-500 md:w-auto hover:shadow-lg ${
                loading && "opacity-50"
              }`}
              onClick={loadMore}
              disabled={loading}
            >
              Tải thêm
            </motion.button>
          </div>
        )}
      </motion.div>
    </>
  );
};

export default Container;
